import { View, TextView } from '@gaming/srvg-classes-core';


export class TextBoxView extends View {
    textView: TextView;
    text: string;
    translate: boolean;

    constructor( options ) {
        options = options || {};
        super( options );

        this.text = options.text || false;
        this.translate = options.translate || true;

    }

    handleDomInstantiated() {
        this.textView = this.addSubView( new TextView( { template: app.templateEngine.template(TextView)} ) );
        this.setText(this.text);
        super.handleDomInstantiated();
    }


    setOptions( options: any, fromConstructor?:boolean ) {
        if (options.text && this.text != options.text){
            this.setText(options.text);
        }
        super.setOptions(options, fromConstructor);
    }

    setText(text){
        if(this.textView && this.textView.setText){
            this.text = text;
            if (this.translate){
                this.text = __(this.text);
            }

            this.textView.setText(this.text);
        }

    }
}